"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyInspectorActionFactoryFromJS = exports.PropertyInspectorActionFactory = void 0;
const BCPropertyInspector_1 = require("@bimser/components/dist/BCPropertyInspector");
const core_1 = require("@bimser/core");
const immutable_1 = require("immutable");
exports.PropertyInspectorActionFactory = (0, immutable_1.Record)({
    windowId: null,
    sourceWindowId: null,
    pluginId: null,
    items: (0, immutable_1.List)(),
    data: null,
    autoClean: true,
    guid: null,
    item: (0, BCPropertyInspector_1.PropertyItemFactory)(),
    itemType: null,
    commonPopoverItems: (0, immutable_1.List)(),
    showCustomBadgeOnLabel: false,
    readOnlyDataProperties: false,
    translateEnabled: false
});
const PropertyInspectorActionFactoryFromJS = function (data) {
    var _a;
    let items = data.items.length
        ? data.items.map(value => {
            if (value.hasOwnProperty('panels')) {
                return (0, BCPropertyInspector_1.TabItemFactoryFromJS)(value);
            }
            else if (value.hasOwnProperty('properties')) {
                return (0, BCPropertyInspector_1.CollapseItemFactoryFromJS)(value);
            }
            else {
                return (0, BCPropertyInspector_1.PropertyItemFactoryFromJS)(value);
            }
        })
        : [];
    // filter unexpected type
    items = items.filter(item => {
        if (item) {
            return true;
        }
        return false;
    });
    const commonPopoverItems = ((_a = data.commonPopoverItems) === null || _a === void 0 ? void 0 : _a.length)
        ? data.commonPopoverItems.map(value => (0, core_1.ItemFactoryFromJS)(value))
        : [];
    return (0, exports.PropertyInspectorActionFactory)({
        windowId: data.windowId,
        sourceWindowId: data.sourceWindowId,
        pluginId: data.pluginId,
        items: (0, immutable_1.List)(items),
        commonPopoverItems: (0, immutable_1.List)(commonPopoverItems),
        data: data.data,
        autoClean: data.autoClean,
        guid: data.guid,
        item: (0, BCPropertyInspector_1.PropertyItemFactoryFromJS)(data.item),
        itemType: data.itemType,
        showCustomBadgeOnLabel: data.showCustomBadgeOnLabel,
        readOnlyDataProperties: data.readOnlyDataProperties,
        translateEnabled: data.translateEnabled
    });
};
exports.PropertyInspectorActionFactoryFromJS = PropertyInspectorActionFactoryFromJS;
//# sourceMappingURL=PropertyInspectorLoad.js.map